import { render, staticRenderFns } from "./InitPayPassword.vue?vue&type=template&id=793ce472&scoped=true&"
import script from "./InitPayPassword.vue?vue&type=script&lang=js&"
export * from "./InitPayPassword.vue?vue&type=script&lang=js&"
import style0 from "./InitPayPassword.vue?vue&type=style&index=0&id=793ce472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ce472",
  null
  
)

export default component.exports